import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, ProductCategoryDTO, ProductFullDTO } from '../../../../services/api/api';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../../../../services/util.service';
import { ErrorService } from '../../../../services/error.service';
import { TagService } from '../../../../services/tag.service';
import { ModalService } from '../../../../services/gui/modal/modal.service';
import { ProductCategoriesComponent } from '../../product-categories/product-categories.component';
import { TranslateService } from '@ngx-translate/core';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-product-details-categories',
  templateUrl: './product-details-categories.component.html',
  styleUrls: ['./product-details-categories.component.scss'],
  standalone: false,
})
export class ProductDetailsCategoriesComponent implements OnInit {
  productId: number;
  product: ProductFullDTO;
  productCategories: ProductCategoryDTO[];
  loading: boolean;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public tagService: TagService,
    private modal: ModalService,
    private translate: TranslateService,
    private destroyRef: DestroyRef
  ) {
    this.productId = undefined;
    this.product = undefined;
    this.productCategories = [];
    this.loading = true;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.productId = +params.productID;
      this.refresh();
    });
  }

  addProductCategory() {
    this.modal
      .showNavigationModal({
        entryComponent: {
          value: ProductCategoriesComponent,
          data: {
            modalType: 'categoriesSelect',
          },
        },
        title: null,
        modalOptions: { windowClass: 'bigXL' },
      })
      .then((result: ProductCategoryDTO) => {
        if (result.id) {
          this.api
            .pm_Product_addProductToCategory(this.productId, result.id)
            .pipe(takeUntilDestroyed(this.destroyRef), take(1))
            .subscribe({
              next: data => {
                if (data) {
                  this.product.categories.push(result);
                }
              },
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        }
      })
      .catch(() => {});
  }

  removeProductCategory(category: ProductCategoryDTO) {
    this.modal
      .confirm({
        title: this.translate.instant('lang.globals.deleteElementValue', { value: category.name }),
        message: this.translate.instant('lang.globals.deleteElementValueQuestion', { value: category.name }),
        yes: this.translate.instant('lang.globals.yes'),
        no: this.translate.instant('lang.globals.no'),
      })
      .then((result: boolean) => {
        if (result) {
          this.api
            .pm_Product_removeProductFromCategory(this.productId, category.id)
            .pipe(takeUntilDestroyed(this.destroyRef), take(1))
            .subscribe({
              next: data => {
                if (data) {
                  const index = this.product.categories.findIndex(x => x.id === category.id);
                  if (index !== -1) {
                    this.product.categories.splice(index, 1);
                  }
                }
              },
              error: error => {
                this.errorHandler.errorHandler(error);
              },
            });
        }
      })
      .catch(() => {});
  }

  refresh() {
    this.loading = true;
    this.api
      .pm_Product_retrieveById(this.productId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: ProductFullDTO) => {
          this.productCategories = e.categories;
          this.product = e;
        },
        error: error => {
          if (!error.status || !(+error.status === 403 || +error.status === 404)) {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }
}
